module.exports = __webpack_public_path__ + "img/logo.13b7ecd9.svg";